import React from "react";
import "./Style.css";
import { McIcon } from "@maersk-global/mds-react-wrapper";
function MetaDataContent({ heading, data }) {
  let headingIsPriority = heading === "Priority";
  let headingIsCustomId = heading === "Incident ID";
  let headingIsIncidentNumber = heading === "Incident Id";
  let headingIsState = heading === "State";
  let snowLink = process.env.REACT_APP_SNOW_LINK;


  return (
    <>
      <div className="metaData_colHead">{heading}</div>
      {headingIsPriority ? (
        <div
          className={
            data == 1
              ? "metaData_colBody highPriorityColor"
              : data == 2
              ? "metaData_colBody mediumPriorityColor"
              : "lowPriorityColor"
          }
        >
          <strong>{data}</strong>
        </div>
      ) : headingIsCustomId ? (
        <h1 className="metaData_incidentNumber">
          <div className="metaData_colBody">
          <a
            href={`${snowLink}number=${data}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              {data}
              <McIcon
                style={{ marginLeft: "5px" }}
                size="12"
                icon="square-arrow-up-right"
              ></McIcon>
            </div>
          </a>
          </div>
          </h1>
      ) : 
      headingIsState ? (
        <div className="metaData_colBody">
          {data === true ? (
            <div className="highPriorityColor"><b>Incomplete</b></div>
          ) : (
            <div className="metaData_stateOpen">{data}</div>
          )}
        </div>
      ) :
      (
        <div className="metaData_colBody">{data ? data : "NA"}</div>
      )}
    </>
  );
}

export default MetaDataContent;